module.exports = __webpack_public_path__ + "img/[刀].c882f931.svg";